import React, { useEffect, useState } from "react";
//import "./orderdetails.css";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { API_URL } from "../../../services/apiConfig";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../../services/axios.instance";
import AFLSuccessModal from "../../../components/AFL/AFLSuccessModal";
import AFLErrorModal from "../../../components/AFL/AFLErrorModal";

const EditTimeLine = () => {
  const location = useLocation();
  const queryClient = useQueryClient();
  const OrderId = new URLSearchParams(location.search).get("OrderId");
  //const { orderDetails } = location.state;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || "1";
  const size = searchParams.get("size") || "10";

  const handleBack = () => {
    navigate({
      pathname: "/dashboard/servicelist",
      search: `?page=${page}&size=${size}`,
    });
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const [driverStartedDateTime, setDriverStartedDateTime] =
    useState<string>("");
  // const [serviceStartedDateTime, setServiceStartedDateTime] =
  //   useState<string>("");
  // const [serviceStartedDateTime, setServiceStartedDateTime] =
  //   useState<string>("");

  const { data: orderDetails } = useQuery({
    queryKey: ["orderDetails", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.SERVICE_DETAILS}/${OrderId}`,
        {
          headers: {
            location: "0,0",
            language: "english",
          },
        }
      );
      return response.data;
    },
  });

  const formatDate = (isoDate: any) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };
  //--------------------------------------------------------------------------
  const driverReachedTimeDifference = (createdAt: string) => {
    const createdDate = new Date(createdAt);
    const driverReachedTime =
      orderDetails?.order_status_history_responses?.find(
        (status: any) =>
          status.delivery_partner_status === "REACHED_CUSTOMER_LOCATION"
      )?.status_changed_at;

    if (!driverReachedTime) return { totalMinutes: 0, formatted: "N/A" };

    const driverReachedDate = new Date(driverReachedTime);
    const driverDiffInSeconds = Math.floor(
      (driverReachedDate.getTime() - createdDate.getTime()) / 1000
    );

    const hours = Math.floor(driverDiffInSeconds / 3600);
    const minutes = Math.floor((driverDiffInSeconds % 3600) / 60);
    const totalMinutes = hours * 60 + minutes;

    return { totalMinutes, formatted: formatTime(hours, minutes) };
  };

  const timeDifference = (createdAt: string) => {
    const now = new Date();
    const createdDate = new Date(createdAt);
    const diffInSeconds = Math.floor(
      (now.getTime() - createdDate.getTime()) / 1000
    );

    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const totalMinutes = hours * 60 + minutes;

    return { totalMinutes, formatted: formatTime(hours, minutes) };
  };

  const formatTime = (hours: number, minutes: number) => {
    if (hours > 0 && minutes > 0) {
      return `${hours} hour(s) ${minutes} minute(s) ago`;
    } else if (hours > 0) {
      return `${hours} hour(s) ago`;
    } else if (minutes > 0) {
      return `${minutes} minute(s) ago`;
    } else {
      return "Just now";
    }
  };
  // const { totalMinutes, formatted } = timeDifference(orderDetails?.createdAt);
  // const statusColor = totalMinutes < 100 ? "text-success" : "text-danger";
  const shouldUseTimeDifference =
    orderDetails?.aaa_service_request_model?.state === "initiate";
  const timeData = shouldUseTimeDifference
    ? timeDifference(orderDetails?.createdAt)
    : { totalMinutes: 0, formatted: "Just now" };

  // Determine status color based on conditions
  const statusColor = shouldUseTimeDifference
    ? timeData.totalMinutes < 10
      ? "text-success"
      : "text-danger"
    : orderDetails?.is_dispatched_within_time
    ? "text-success"
    : "text-danger";

  const { totalMinutes: totalMinutesDriverReached } =
    driverReachedTimeDifference(orderDetails?.createdAt);

  const driverReachedStatusColor =
    totalMinutesDriverReached < 60 ? "text-success" : "text-danger";
  // Update details mutation
  const { mutate: updateDetails, isPending: isUpdating } = useMutation({
    mutationFn: async (data: {}) => {
      const response = await axiosInstance.post(API_URL.SERVICE_DETAILS_EDIT, {
        order_number: orderDetails?.order_service_details?.orderNumber,
        ...data,
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ["orderDetails", OrderId] });
      setShowSuccessModal(true);
    },
    onError: () => {
      setShowErrorModal(true);
    },
  });

  // Set initial values when orderDetails changes
  useEffect(() => {
    if (orderDetails) {
      // Set initial driver started datetime if exists
      const acceptedStatus = orderDetails?.order_status_history_responses?.find(
        (status: any) => status.delivery_partner_status === "DELIVERY_ACCEPTED"
      );
      if (acceptedStatus?.status_changed_at) {
        // Use the exact datetime string from the server without timezone conversion
        const dateStr = acceptedStatus.status_changed_at;
        // Extract just the date and time parts (YYYY-MM-DDTHH:MM:SS)
        const dateTimeStr = dateStr.split(".")[0];
        // Truncate to just YYYY-MM-DDTHH:MM for the datetime-local input
        setDriverStartedDateTime(dateTimeStr.substring(0, 16));
      }
    }
    // Set initial service started datetime if exists
    // const serviceStartedStatus =
    //   orderDetails?.order_status_history_responses?.find(
    //     (status: any) =>
    //       status.delivery_partner_status ===
    //       (orderDetails?.order_service_details?.serviceType === "DISTANCE_BASED"
    //         ? "VEHICLE_COLLECTED"
    //         : "SERVICE_STARTED")
    //   );
    // if (serviceStartedStatus?.status_changed_at) {
    //   const dateStr = serviceStartedStatus.status_changed_at;
    //   const dateTimeStr = dateStr.split(".")[0];
    //   setServiceStartedDateTime(dateTimeStr.substring(0, 16));
    // }
    // const serviceStartedStatus =
    //   orderDetails?.order_status_history_responses?.find(
    //     (status: any) =>
    //       status.delivery_partner_status ===
    //       (orderDetails?.order_service_details?.serviceType === "DISTANCE_BASED"
    //         ? "VEHICLE_COLLECTED"
    //         : "SERVICE_STARTED")
    //   );
    // if (serviceStartedStatus?.status_changed_at) {
    //   const dateStr = serviceStartedStatus.status_changed_at;
    //   const dateTimeStr = dateStr.split(".")[0];
    //   setServiceStartedDateTime(dateTimeStr.substring(0, 16));
    // }
  }, [orderDetails]);

  interface UpdateData {
    driver_started_date_time?: string;
    service_started_date_time?: string;
  }

  const handleUpdate = () => {
    const updateData: UpdateData = {};
    // Add datetime fields if they have values
    if (driverStartedDateTime) {
      updateData.driver_started_date_time = `${driverStartedDateTime}:00`;
    }
    // if (serviceStartedDateTime) {
    //   updateData.service_started_date_time = `${serviceStartedDateTime}:00`;
    // }
    // if (serviceStartedDateTime) {
    //   updateData.service_started_date_time = `${serviceStartedDateTime}:00`;
    // }
    // Make the API call with all updates
    if (Object.keys(updateData).length > 0) {
      updateDetails(updateData);
    }
  };

  return (
    <div>
      <div className="col-12">
        <div className="row">
          <div className="col-md-12 text-start div-bg-invoice-details pt-3">
            <div className="card card-bg-invoice-details">
              <div className="card-body px-5">
                <div>
                  <button onClick={handleBack} className="all_button_style">
                    Back
                  </button>
                </div>
                <div className="row pb-3">
                  <div className="table-responsive pt-3">
                    <div className="mb-3 text-center invoice-text-yellow-afl">
                      <h4>
                        Job Reference No:{" "}
                        <span className="">
                          {orderDetails?.order_service_details?.referenceNumber}
                        </span>
                      </h4>
                    </div>
                    <div className="row pt-3">
                      {/* LEFT SIDE TABLE */}
                      <div className="col-md-6">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <th>Vehicle Make</th>
                                <td>
                                  {
                                    orderDetails?.order_service_details
                                      ?.vehicleMake
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Vehicle Model</th>
                                <td>
                                  {
                                    orderDetails?.order_service_details
                                      ?.carModel
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Mobile</th>
                                <td>
                                  {
                                    orderDetails?.aaa_service_request_model
                                      ?.mobileNumber
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Plate Number</th>
                                <td>
                                  {
                                    orderDetails?.aaa_service_request_model
                                      ?.plateNumber
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Chassis Number</th>
                                <td>{orderDetails?.chassis_number}</td>
                              </tr>
                              <tr>
                                <th>Service Date</th>
                                <td>{formatDate(orderDetails?.createdAt)}</td>
                              </tr>

                              {orderDetails?.recollection_location ? (
                                <>
                                  <tr>
                                    <th>Location From</th>
                                    <td>
                                      {orderDetails?.delivery_location?.address}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Location To</th>
                                    <td>
                                      {
                                        orderDetails?.recollection_location
                                          ?.address
                                      }
                                    </td>
                                  </tr>
                                </>
                              ) : (
                                <tr>
                                  <th>Location To</th>
                                  <td>
                                    {orderDetails?.delivery_location?.address}
                                  </td>
                                </tr>
                              )}

                              <tr>
                                <th>Comments AFL</th>
                                <td>
                                  {
                                    orderDetails?.order_service_details
                                      ?.aflComments
                                  }
                                </td>
                              </tr>

                              {orderDetails?.merchant_comment && (
                                <tr>
                                  <th>Comments</th>
                                  <td>{orderDetails?.merchant_comment}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* RIGHT SIDE TABLE */}
                      <div className="col-md-6">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <th>Customer Name</th>
                                <td>{orderDetails?.customer_name}</td>
                              </tr>
                              <tr>
                                <th>Service Type</th>
                                <td>
                                  {
                                    orderDetails?.order_service_details
                                      ?.serviceName
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Service Status</th>
                                <td>
                                  {
                                    orderDetails?.aaa_service_request_model
                                      ?.state
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Scheduled Date & Time (if any)</th>
                                <td>
                                  {formatDate(
                                    orderDetails?.order_service_details
                                      ?.scheduledFor
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>Driver Name</th>
                                <td>
                                  {orderDetails?.aaa_service_request_model
                                    ?.driverName ??
                                    orderDetails?.delivery_boy_details
                                      ?.firstName}
                                </td>
                              </tr>
                              <tr>
                                <th>Driver Contact</th>
                                <td>
                                  {orderDetails?.aaa_service_request_model
                                    ?.driverPhone ??
                                    orderDetails?.delivery_boy_details
                                      ?.phoneNumber}
                                </td>
                              </tr>
                              <tr>
                                <th>Comments from AAA agent</th>
                                <td>
                                  {orderDetails?.aaa_service_request_model
                                    ?.comments?.length > 0 ? (
                                    orderDetails?.aaa_service_request_model?.comments.map(
                                      (comment: any, index: number) => (
                                        <div key={index}>
                                          {comment?.comment}
                                          <br />
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <span>No comments available</span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>Initiated DT</th>
                                <td>
                                  {formatDate(orderDetails?.createdAt)}
                                  <span className="text-muted">
                                    <span className={statusColor}>
                                      {" "}
                                      : STATUS
                                    </span>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 pt-3">
                    <div className="invoice-div-head-afl">
                      Driver Started DT<span className="merchantStar">*</span>
                    </div>
                    <div className="invoice-div-data-afl">
                      <input
                        type="datetime-local"
                        className="form-control form-control-sm"
                        value={driverStartedDateTime}
                        onChange={(e) =>
                          setDriverStartedDateTime(e.target.value)
                        }
                        disabled={isUpdating}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-6 pt-3">
                    <div className="invoice-div-head-afl">
                      Service Started DT<span className="merchantStar">*</span>
                    </div>
                    <div className="invoice-div-data-afl">
                      <input
                        type="datetime-local"
                        className="form-control form-control-sm"
                        value={serviceStartedDateTime}
                        onChange={(e) =>
                          setServiceStartedDateTime(e.target.value)
                        }
                        disabled={isUpdating}
                      />
                    </div>
                  </div> */}
                  <div className="row mt-4">
                    <div className="col-12 text-end">
                      <button
                        className="invoice-approve-btn px-4"
                        onClick={handleUpdate}
                        disabled={isUpdating || !driverStartedDateTime}
                      >
                        {isUpdating ? "Updating..." : "UPDATE"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Success Modal */}
      <AFLSuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onNav={() => {
          navigate("/dashboard/servicelist");
          setShowSuccessModal(false);
        }}
        message="Details updated successfully"
      />
      {/* Error Modal */}
      <AFLErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        message="Failed to update details. Please try again."
      />
    </div>
  );
};

export default EditTimeLine;
